import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './client';

export interface Notification {
    id: string;
    icon: string;
    title: string;
    desc: string;
    link: string;
    time: string;
    unread: boolean;
}

async function fetchNotifications(): Promise<Notification[]> {
    const res = await api.get<Notification[]>('/notifications');
    return res.data;
}

// Polled every 60s so the bell unread count stays roughly current without
// pushing a full websocket dependency in. refetchOnWindowFocus picks up
// anything generated while the tab was backgrounded.
export function useNotifications(enabled: boolean = true) {
    return useQuery({
        queryKey: ['notifications', 'list'] as const,
        queryFn: fetchNotifications,
        enabled,
        staleTime: 30_000,
        refetchInterval: 60_000,
        refetchOnWindowFocus: true,
    });
}

export function useMarkNotificationRead() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async (id: string) => {
            await api.patch(`/notifications/${id}`, { unread: false });
        },
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['notifications'] });
        },
    });
}
